export const COACH_ONBOARDING_ERROR = 'COACH_ONBOARDING_ERROR';
export const COACH_ONBOARDING_LOADING = 'COACH_ONBOARDING_LOADING';
export const COACH_ONBOARDING_NEXT_STEP = 'COACH_ONBOARDING_NEXT_STEP';
export const COACH_ONBOARDING_GET = 'COACH_ONBOARDING_GET';
export const COACH_ONBOARDING_UPDATE_COMPLETED_STEP = 'COACH_ONBOARDING_UPDATE_COMPLETED_STEP';
